module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/379.c796c75a.png";